import { BoostBrandFactory } from '../types';

export const getAcornBoostBrand: BoostBrandFactory = (theme) => ({
	title: 'Acorn Chat',
	avatarUrl: '/acorn-chat-avatar.png',
	styling: {
		pace: 'fast',
		primaryColor: theme.palette.primary.main,
		avatarUrl: '/acorn-chat-avatar.png',
		buttons: {
			backgroundColor: theme.palette.secondary.main,
			focusBackgroundColor: theme.palette.secondary.light,
		},
	},
});
